module.exports = __webpack_public_path__ + "static/media/Ncc.35b5c453.png";